import React from 'react';
import {Link} from 'react-router-dom';
import {Box, FileText, PlusCircle,} from 'react-feather';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';

const ENTITY_ROUTE = 'substances';

export const NewSafetyDataSheetButton = ({ resource }, { locale }) => {
	return (
		<span className="CrudButton">
			<span className="tooltip">{getLabel(locale, 'substances.newSds')}</span>
			<Link to={['', ENTITY_ROUTE, resource.id, 'safetyDataSheet', 'new'].join('/')}>
				<PlusCircle size={18} />
			</Link>
		</span>
	);
};

export const ViewSafetyDataSheetButton = ({ resource }, { locale }) => {
	let disabled =  resource.lastSafetyDataSheet == null;
	if(disabled){
		let tooltip = getLabel(locale, 'substances.viewSdsDisabled');
		return (
			<span className="CrudButton">
				<span className="tooltip">{tooltip}</span>
				<a className="disabled">
					<FileText size={18} />
				</a>
			</span>
		);
	}else{
		return (
			<span className="CrudButton">
				<span className="tooltip">{getLabel(locale, 'substances.viewSds')}</span>
				<Link to={['', ENTITY_ROUTE, resource.id, 'safetyDataSheet', resource.lastSafetyDataSheet.id, 'view'].join('/')}>
					<FileText size={18} />
				</Link>
			</span>
		);
	}
};


export const NewSafetyDataSheetEvaluationButton = ({ resource }, { locale }) => {
	if (resource.lastSafetyDataSheet != undefined) {
		let disabled = resource.lastSafetyDataSheet.lastSafetyDataSheetEvaluation != undefined;

		if (disabled) {
			let tooltip = getLabel(locale, 'substances.newSdsEvaluationDisabled');
			return (
				<span className="CrudButton">
					<span className="tooltip">{tooltip}</span>
					<a className="disabled">
						<PlusCircle size={18} />
					</a>
				</span>
			);
		} else {
			return (
				<span className="CrudButton">
					<span className="tooltip">{getLabel(locale, 'substances.newSdsEvaluation')}</span>
					<Link to={['', ENTITY_ROUTE, resource.lastSafetyDataSheet.id, 'safetyDataSheetEvaluation', 'new'].join('/')}>
						<PlusCircle size={18} />
					</Link>
				</span>
			);
		}
	} else {
		return (
			<span className="CrudButton">
			</span>
		)
	}
};

export const ViewSafetyDataSheetEvaluationButton = ({ resource }, { locale }) => {
	let disabled = false;
	if (resource.lastSafetyDataSheet != undefined && resource.lastSafetyDataSheet.lastSafetyDataSheetEvaluation != undefined) {
		return (
			<span className="CrudButton">
				<span className="tooltip">{getLabel(locale, 'substances.viewSdsEvaluation')}</span>
				<Link to={['', ENTITY_ROUTE, resource.lastSafetyDataSheet.id, 'safetyDataSheetEvaluation', resource.lastSafetyDataSheet.lastSafetyDataSheetEvaluation.id, 'view'].join('/')}>
					<FileText size={18} />
				</Link>
			</span>
		);
	} else {
		return (
			<span className="CrudButton">
			</span>
		)
	}
}


export const ArchiveSafetyDataSheetButton = ({ resource }, { locale }) => (
	<span>
		{resource.lastSafetyDataSheet != undefined ?
			<span className="CrudButton">
				<span className="tooltip">{getLabel(locale, 'substancesManagement.archive')}</span>
				<Link to={['', ENTITY_ROUTE, resource.id, 'safetyDataSheet'].join('/')}>
					<Box size={18} />
				</Link>
			</span> : ''
		}
	</span>
);

ArchiveSafetyDataSheetButton.contextTypes = {
	locale: PropTypes.string,
};



NewSafetyDataSheetButton.contextTypes = {
	locale: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/main/pages/SubstancesButtons.js